import React, { FC, ChangeEvent } from 'react';
import {
  CheckboxProps, ControlBox, Icon, Box,
  Text,
} from '@chakra-ui/core';
import { Hidden } from '../Hidden'

export interface Props extends CheckboxProps {
  title: string;
  subTitle?: string;
  disabled?: boolean;
  checked: boolean;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const DetailRowWithCheckBox: FC<Props> = ({
  title,
  subTitle,
  onChange,
  disabled,
  value,
  checked
}) => {
  console.log(checked, 'deailrow')

  return (
    <label>
      <Box
      d="flex"
      flexDir="row"
      justifyContent="space-between"
      backgroundColor="white"
      borderTop="1px solid"
      borderColor="gray.500"
      py="2"
      px="6"
      minH="48px"
      h="48px"
      w="100%"
      >
        <Box verticalAlign="top" flex="4" d="flex" flexDir="column" alignSelf="center">
          <Text m="0" textAlign="left" fontWeight="bold" fontSize="12px">
            {title}
          </Text>
          {subTitle && (
            <Text m="0" textAlign="left" fontSize="11px">
              {subTitle}
            </Text>
          )}
        </Box>

        <Hidden as="input" type="checkbox" checked={checked} value={value} onChange={onChange} isDisabled={disabled}/>

        <ControlBox
            d="flex"
            alignSelf="center"
            border="2px solid"
            size="16px"
            borderRadius={2}
            verticalAlign="center"
            bg="white"
            marginRight="1"
            borderColor="gray.50"
            type="checkbox"
            _disabled={{ bg: "white", color: "white", borderColor: "gray.200" }}
            _checked={{ bg: "primary.500", color: "white", borderColor: "primary.500" }}
            _focus={{ borderColor: "primary.500", boxShadow: "outline" }}
          >
            <Icon name="check" size="10px"/>
        </ControlBox>
      </Box>
    </label>
  );
};
